<script>
    import { Router, Link, Route, link, navigate } from "svelte-routing";
    import { onMount } from 'svelte';

    import { _completeExamData, _userObj } from "./store.js";

    export let token;

    let userObj = {
        name: "",
        mobileNo: ""
    };

    let loaded = false;

    let completeExamData = {};

    let maxMarks = 0;

    let showError = false

    let checked = false;

    async function api_getInfo() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            token: token,
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch(  '/testAPI/getInfo', requestOptions);
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }

    async function api_getMyTests(testObj) {
        var requestOptions = {
            method: "GET",
        };
        try {
            var resObj = await fetch(  "/testAPI/testData/" + testObj.orgId + "/" + testObj.testId + ".json", requestOptions);
            console.log("resObj : ", resObj)
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }

    _userObj.subscribe(value => { userObj = value });
    _completeExamData.subscribe(value => { 
        maxMarks = value.totalMaxMarks;
        
        completeExamData = value });
    
    onMount(async () => {
        if (!userObj.name) {
            let tokenRes = await api_getInfo();
            userObj = tokenRes.userObj;
            _userObj.set(userObj);

            if (tokenRes.doneTest) {
                alert("Test already submitted")
                navigate("/result/" + tokenRes.doneTest._id, { replace: true })
            }
            
            // let response = await api_getMyTests({
            //     orgId: userObj.orgId,
            //     testId: tokenRes.testId
            // });
            // _completeExamData.set(response);
            // console.log("response : ", response)
            // console.log(" completeExamData : ", completeExamData)
            _completeExamData.set(JSON.parse(tokenRes.completeTestData.testData));

            if (tokenRes.onGoingTest) {
                navigate("/questions/" + token + "/" + tokenRes.onGoingTest.currentQuestionNo + "/" + tokenRes.onGoingTest.currentSectionNo)
            }

        } else {
            console.log("Loaded")
        }

        loaded = true;
        
    });
</script>


{#if loaded}
    <div class="inst-container">
        <div class="inst-header">
        </div>
        <div class="inst-general-inst">
            <div class="inst-body">
                <!-- <h4> Exam Instructions: </h4> -->
                <div class="exam-group">Test</div>
                <div class="exam-name-b">{completeExamData.name? completeExamData.name : ""}</div>
                <h4> Duration: <span class="durMinute">{completeExamData.duration ? completeExamData.duration : ""}</span>
                    Min </h4>
                <h4> Marks: <span class="totalMark">{maxMarks}</span> </h4>
                <h4> Read the following instructions carefully : </h4>
                <div start="1" class="for-all-exams generalInst">
                    {@html completeExamData.examInstructions? completeExamData.examInstructions : ""}
                </div>
            </div>
            <div class="inst-user-info">
                <div class="profile-pic">
                    <div class="circle-avatar">
                        <img src="/images/user.jpg" alt="">
                    </div>
                </div>
    
                <div class="userData">
                    <b>Name:</b> <span id="userName">{userObj.name}</span>
                    <br>
                    <b>Mobile No:</b> <span id="userEmail">{userObj.mobileNo}</span>
                </div>
            </div>
        </div>
    
        <div class="inst-declaration">
            <div class="test-start-acceptance js-test-start-acceptance">
                <p> <b class:has-error={showError && !checked}> Declaration: </b> 
                    {#if showError && !checked}
                        <span class="has-error">(Please read and check this)</span>
                    {/if}
                
                </p> <label class="test-instructions-declaration"> <input type="checkbox" 
                    bind:checked
                        name="instructions" ng-model="$root.checkboxModel.isAccepted" ng-true-value="true"
                        ng-false-value="false" class="ng-valid ng-dirty ng-valid-parse ng-touched"> I have read all the
                    instructions carefully and have understood them. I agree not to cheat or use unfair means in this
                    examination. I understand that using unfair means of any sort for my own or someone else’s advantage
                    will
                    lead to my immediate disqualification. </label>
            </div>
        </div>
        <div class="inst-footer">
    
            <button class="bottom-btn primary-color" on:click={()=>navigate("/start/"+token)}>
                Previous
            </button>
            <div class="f1"></div>
            <button class="bottom-btn primary-color launch-test"  on:click={()=>{
                if(!checked) showError = true;
                else navigate("/questions/"+token+"/1/1")}}>
                Launch Test
            </button>
        </div>
    
    </div>
{/if}

